module.exports = __webpack_public_path__ + "img/interviewpic2.30eeff16.png";